import { render, staticRenderFns } from "./MyProducts.vue?vue&type=template&id=713a37f1&scoped=true"
import script from "./MyProducts.vue?vue&type=script&lang=js"
export * from "./MyProducts.vue?vue&type=script&lang=js"
import style0 from "./MyProducts.vue?vue&type=style&index=0&id=713a37f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a37f1",
  null
  
)

export default component.exports